import { useEffect, useRef, useState } from 'react'

import { IPopupMethods } from 'core-components/library/popup'

export const useTargetSize = () => {
  const popupRef = useRef<IPopupMethods>(null)
  const [targetWidth, setTargetWidth] = useState<number>()

  const updateSize = () => {
    if (popupRef.current?.rootWidth !== targetWidth) {
      setTargetWidth(popupRef.current?.rootWidth)
    }
  }

  const updateSizeDelayed = () => {
    // wait browser tab size changed
    setTimeout(updateSize, 10)
  }

  useEffect(() => {
    updateSize()
    window.addEventListener('resize', updateSizeDelayed)
    return () => {
      window.removeEventListener('resize', updateSizeDelayed)
    }
  })

  return { popupRef, targetWidth }
}
